import {createSvgIcon} from "@mui/material";

export const TelegramIcon = createSvgIcon(
    <path d="M8.1686 16.9369L8.50232 11.893L17.751 3.64542C18.161 3.27356 17.6652 3.10194 17.1217 3.41659L5.70863 10.5581L0.769628 9.00396C-0.28873 8.70838 -0.298265 7.98374 1.008 7.45932L20.2396 0.117559C21.1168 -0.273367 21.9654 0.327323 21.6222 1.67172L18.3422 16.9369C18.1134 18.0238 17.4555 18.2813 16.5401 17.7855L11.5534 14.1337L9.16022 16.4315C8.89325 16.708 8.66441 16.9369 8.1686 16.9369Z"/>,
    'Telegram'
);